// extracted by mini-css-extract-plugin
export var searchHeader = "_k-0";
export var searchHeaderDark = "_k-1";